/* COH Custom-Konfigurator (randlose Fassungen) – Logik. Gleiche Schnittstelle wie glass-configurator.js (window.GC_API). */
(function () {
  'use strict';
  var D = window.GC_DATA;
  var root = document.getElementById('gc');
  if (!D || !root || !D.custom) return;

  var $ = function (s) { return root.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

  function money(cents) {
    var v = cents / 100, txt;
    try {
      txt = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 }).format(v);
    } catch (e) { txt = v + ' €'; }
    /* Preis-Element für den Währungswechsel (App Doubly): Basis-Betrag in Cent, Basiswährung EUR */
    return '<span class="money" doubly-currency-eur="' + Math.round(cents) + '" doubly-currency="EUR">' + txt + '</span>';
  }
  var convTimer = null;
  function convertSoon() {
    clearTimeout(convTimer);
    convTimer = setTimeout(function () {
      try { if (typeof window.doublyChangeEvent === 'function') window.doublyChangeEvent(); } catch (e) { }
    }, 30);
  }
  /* Feste Preis-Texte (z. B. "350 €", "ab 149 €") einmalig als Preis-Element markieren, damit sie umgerechnet werden */
  function wrapStatic() {
    var re = /(\d{1,3}(?:\.\d{3})*|\d+)(?:,(\d{1,2}))?\s?€/g;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var nodes = [], n;
    while ((n = walker.nextNode())) {
      re.lastIndex = 0;
      if (/^(SCRIPT|STYLE|TEXTAREA|OPTION)$/.test(n.parentNode.nodeName)) continue;
      if (re.test(n.nodeValue) && !(n.parentNode.closest && n.parentNode.closest('.money'))) nodes.push(n);
      re.lastIndex = 0;
    }
    nodes.forEach(function (tn) {
      var html = '', last = 0, t = tn.nodeValue, m;
      re.lastIndex = 0;
      while ((m = re.exec(t))) {
        var euro = parseInt(m[1].replace(/\./g, ''), 10);
        var cent = m[2] ? parseInt((m[2] + '0').slice(0, 2), 10) : 0;
        html += esc(t.slice(last, m.index)) + '<span class="money" doubly-currency-eur="' + (euro * 100 + cent) + '" doubly-currency="EUR">' + esc(m[0]) + '</span>';
        last = m.index + m[0].length;
      }
      html += esc(t.slice(last));
      var sp = document.createElement('span');
      sp.innerHTML = html;
      var par = tn.parentNode;
      while (sp.firstChild) par.insertBefore(sp.firstChild, tn);
      par.removeChild(tn);
    });
    convertSoon();
  }
  function esc(s) { return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
  function dec(n) { return (n < 0 ? '-' : n > 0 ? '+' : '') + Math.abs(n).toFixed(2).replace('.', ','); }
  function one(n) { return n.toFixed(1).replace('.', ','); }

  /* ---------- Auswahlfelder füllen ---------- */
  function fill(id, values, placeholder, defVal) {
    var sel = document.getElementById(id);
    if (!sel) return;
    var h = '';
    if (placeholder) h += '<option value="">' + placeholder + '</option>';
    values.forEach(function (v) { h += '<option value="' + v.value + '"' + (defVal === v.value ? ' selected' : '') + '>' + v.label + '</option>'; });
    sel.innerHTML = h;
  }
  var sph = [], cyl = [], ax = [], pd = [], i;
  for (i = -600; i <= 600; i += 25) sph.push({ value: i === 0 ? '0,00' : dec(i / 100), label: i === 0 ? '0,00' : dec(i / 100) });
  for (i = -200; i <= 200; i += 25) cyl.push({ value: i === 0 ? '0,00' : dec(i / 100), label: i === 0 ? '0,00' : dec(i / 100) });
  for (i = 1; i <= 180; i++) ax.push({ value: String(i), label: i + '°' });
  for (i = 50; i <= 80; i++) pd.push({ value: one(i / 2), label: one(i / 2) });
  ['R', 'L'].forEach(function (e) {
    fill('gc_sph' + e, sph, 'Wählen', null);
    fill('gc_cyl' + e, cyl, null, '0,00');
    fill('gc_ax' + e, ax, '–', null);
    fill('gc_pd' + e, pd, '–', null);
  });
  var pct = [];
  for (i = 20; i <= 80; i += 10) pct.push({ value: String(i), label: i + ' %' });
  fill('gc_tpct', pct, 'Wählen', null);
  var dp = [];
  for (i = 80; i >= 30; i -= 10) dp.push({ value: String(i), label: 'oben ' + i + ' % · unten ' + (i - 15) + ' %' });
  fill('gc_dpct', dp, 'Wählen', null);

  /* ---------- Zustand ---------- */
  function val(name) {
    var el = root.querySelector('input[name="' + name + '"]:checked');
    return el ? el.value : '';
  }
  function g(id) { var el = document.getElementById(id); return el ? el.value : ''; }
  function chk(id) { var el = document.getElementById(id); return !!(el && el.checked); }

  var GLAS = 'Custom: Angefertigtes Premium Glas 1,6';
  var TINT = { v30: 'Verlauf 30 % auf 0 %', v65: 'Verlauf 65 % auf 0 %', t75: 'Vollton 75 %', t85: 'Vollton 85 %' };
  var ADD_LABEL = { blue: 'Blaulichtfilter', grav: 'Cartier-Gravur', dick: 'Sonderdicke', facet: 'Schmuckfacette', cut: 'Cut-outs' };
  var ADD_ORDER = ['blue', 'grav', 'dick', 'facet', 'cut'];

  function mainForm() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var k = 0; k < forms.length; k++) {
      var pid = forms[k].querySelector('[name="product-id"]');
      if (pid && String(pid.value) === String(D.productId)) return forms[k];
    }
    return forms[0] || null;
  }
  function frameId() {
    var f = mainForm();
    var el = f && f.querySelector('[name="id"]');
    return el ? String(el.value) : '';
  }

  function state() {
    var color = root.querySelector('input[name="gc_color"]:checked');
    return {
      mode: val('gc_mode'), glas: 'custom', extra: val('gc_extra'), shape: val('gc_shape'),
      tint: val('gc_tint'), ttype: val('gc_ttype'), tpct: g('gc_tpct'), dpct: g('gc_dpct'),
      color: color ? color.value : '', colorGroup: color ? color.getAttribute('data-group') : '',
      rx: val('gc_rx'), trans: val('gc_trans'),
      add: ADD_ORDER.filter(function (k) { return chk2(k); })
    };
  }
  function chk2(v) {
    var el = root.querySelector('input[name="gc_add"][value="' + v + '"]');
    return !!(el && el.checked);
  }
  function tintLabel(s) {
    if (s.colorGroup === 'duo') {
      return s.dpct ? 'oben ' + s.dpct + ' % / unten ' + (Number(s.dpct) - 15) + ' %' : '';
    }
    if (s.colorGroup === 'sonder') {
      if (!s.ttype || !s.tpct) return '';
      return s.ttype === 'verlauf' ? 'Verlauf ' + s.tpct + ' % auf 0 %' : 'Vollton ' + s.tpct + ' %';
    }
    return s.tint ? TINT[s.tint] : '';
  }
  function isGlass() { return val('gc_mode') === 'glas'; }

  /* ---------- Abhängigkeiten ---------- */
  function apply() {
    var s = state();
    var on = s.mode === 'glas';
    $('#gc_panel').hidden = !on;
    document.documentElement.classList.toggle('gc-on', on);
    if (!on) { render(); sync(); return; }

    $('#gc_trans_panel').hidden = s.extra !== 'trans';
    $('#gc_tint_panel').hidden = s.extra !== 'tint';
    $('#gc_steps_hint').hidden = !!s.color;
    $('#gc_std_steps').hidden = s.colorGroup !== 'std';
    $('#gc_free_steps').hidden = s.colorGroup !== 'sonder';
    $('#gc_duo_steps').hidden = s.colorGroup !== 'duo';

    var verlauf = s.tint === 'v30' || s.tint === 'v65';
    $$('.gc-sw img[data-voll]').forEach(function (im) {
      var want = verlauf && im.getAttribute('data-verlauf') ? im.getAttribute('data-verlauf') : im.getAttribute('data-voll');
      if (im.getAttribute('src') !== want) im.setAttribute('src', want);
    });

    var rxOn = s.rx === 'yes';
    $('#gc_rx_panel').hidden = !rxOn;
    ['R', 'L'].forEach(function (e) {
      var c = g('gc_cyl' + e);
      var a = document.getElementById('gc_ax' + e);
      var needAx = c && c !== '0,00';
      a.disabled = !needAx;
      if (!needAx) a.value = '';
    });
    var unk = chk('gc_pd_unknown');
    ['gc_pdR', 'gc_pdL'].forEach(function (id) {
      var el = document.getElementById(id);
      el.disabled = unk;
      if (unk) el.value = '';
    });
    sync();
    render();
  }
  function sync() {
    $$('.gc__opt, .gc-sw, .gc__chip').forEach(function (l) {
      var inp = l.querySelector('input');
      if (inp) l.classList.toggle('is-on', inp.checked);
    });
  }

  /* ---------- Positionen & Preise ---------- */
  function lines() {
    var s = state();
    var out = [];
    if (s.mode !== 'glas') return out;
    var A = D.addons;
    if (A.custom.id) out.push({ id: A.custom.id, price: A.custom.price, label: GLAS, kind: 'glas' });
    if (s.rx === 'yes' && A.rx.id) out.push({ id: A.rx.id, price: A.rx.price, label: 'Mit Sehstärke', kind: 'extra' });
    s.add.forEach(function (k) {
      if (A[k] && A[k].id) out.push({ id: A[k].id, price: A[k].price, label: ADD_LABEL[k], kind: 'extra' });
    });
    return out;
  }
  function render() {
    var box = $('#gc_lines');
    if (!box) return;
    var s = state();
    if (s.mode !== 'glas') { box.innerHTML = ''; $('#gc_eta').textContent = ''; return; }
    var fv = D.variants[frameId()];
    var fp = fv ? fv.price : 0;
    var ls = lines();
    var total = fp;
    var h = '<div class="gc__line"><span>Fassung</span><span>' + money(fp) + '</span></div>';
    if (s.shape) h += '<div class="gc__line"><span>Glasform</span><span>' + s.shape + '</span></div>';
    ls.forEach(function (l) {
      total += l.price;
      h += '<div class="gc__line"><span>' + l.label + '</span><span>+ ' + money(l.price) + '</span></div>';
    });
    if (s.extra === 'trans') {
      h += '<div class="gc__line"><span>Selbsttönend (Transitions)' + (s.trans ? ', ' + s.trans : '') + '</span><span>inklusive</span></div>';
    }
    if (s.extra === 'tint') {
      var tl = tintLabel(s);
      h += '<div class="gc__line"><span>Tönung' + (tl ? ', ' + tl : '') + (s.color ? ', ' + s.color : '') + '</span><span>inklusive</span></div>';
    }
    h += '<div class="gc__line gc__line--total"><span>Gesamt</span><span>' + money(total) + '</span></div>';
    box.innerHTML = h;
    preview();
    convertSoon();
    $('#gc_eta').textContent = etaText() + ' Der Versand erfolgt gemeinsam, sobald alles fertig ist.';
  }
  function etaText() {
    /* Gravur, Schmuckfacette oder Cut-outs verlängern die Lieferzeit, alles andere nicht */
    var s = state();
    var long = s.add.indexOf('grav') > -1 || s.add.indexOf('facet') > -1 || s.add.indexOf('cut') > -1;
    return long ? 'Lieferzeit ca. 30 Werktage.' : 'Lieferzeit ca. 14 Werktage.';
  }

  
  /* ---------- Schematische Vorschau ---------- */
  var SHAPE_D = {"Vibe":"M537 75L545 92L552 110L557 129L560 147L558 179L551 213L544 237L533 263L520 287L506 310L499 319L488 330L475 339L460 349L447 355L426 361L394 368L363 373L334 376L301 378L238 378L207 375L178 372L129 362L106 354L88 346L75 338L68 329L55 296L46 257L41 214L40 170L48 121L57 86L62 74L68 65L76 57L83 51L100 45L126 38L159 31L188 27L276 22L322 22L363 23L396 25L432 30L462 35L488 42L509 49L520 54L529 63Z","474":"M559 106L560 119L556 164L541 237L526 283L516 299L505 310L483 321L407 337L321 349L244 356L206 356L185 352L126 330L112 323L97 309L87 292L66 234L48 170L40 127L44 110L59 87L81 62L90 58L167 48L243 44L360 44L444 51L495 66L548 91Z","439":"M557 121L560 182L551 241L541 269L517 304L480 344L451 366L431 375L379 382L288 384L165 383L149 379L115 354L78 316L56 287L43 259L40 240L40 163L43 132L46 121L102 65L148 32L161 26L193 21L291 16L396 17L442 22L469 36L508 65L555 112Z","550":"M550 70L556 83L560 110L557 168L550 200L537 239L518 283L496 317L477 331L401 354L342 363L301 365L219 363L136 354L111 350L79 338L74 331L62 299L40 206L40 148L50 98L56 81L74 66L158 47L224 38L266 35L397 35L478 43L535 56L543 60Z","622":"M552 85L560 109L558 194L552 231L531 271L502 313L467 350L454 358L387 369L290 374L209 371L156 365L128 355L101 336L70 307L50 276L43 247L40 209L40 88L43 80L56 68L101 42L128 34L172 29L255 26L443 29L485 34L510 42L534 61Z","362":"M537 87L552 117L560 150L560 194L552 231L537 269L509 318L484 345L468 356L454 361L409 369L331 374L213 374L177 372L148 367L128 356L96 324L66 281L45 238L40 212L40 165L45 139L58 112L80 80L103 57L121 46L183 35L264 27L361 26L408 28L483 40L500 49L514 60Z","660":"M531 55L546 82L557 115L560 134L557 161L546 198L506 285L478 331L452 355L427 366L401 370L367 374L262 375L176 370L116 361L102 355L92 345L64 285L50 242L43 204L40 155L43 90L57 68L78 49L92 44L225 28L332 25L416 28L490 36L520 44Z","171":"M536 54L553 86L560 114L560 155L553 188L540 234L516 291L493 330L466 355L435 367L375 380L321 387L232 388L178 385L107 373L85 365L69 348L57 321L45 264L40 198L40 150L45 107L57 69L67 52L75 45L104 33L181 18L266 12L356 12L442 17L491 23L515 32Z","Original":"M562 205L561 240L559 261L554 278L548 294L540 307L531 320L519 331L506 340L491 349L475 356L456 363L435 368L412 372L385 375L353 376L300 377L247 376L215 375L188 372L165 368L144 363L125 356L109 349L94 340L81 331L69 320L60 307L52 294L46 278L41 261L39 240L38 205L39 170L41 149L46 132L52 116L60 103L69 90L81 79L94 70L109 61L125 54L144 47L165 42L188 38L215 35L247 34L300 33L353 34L385 35L412 38L435 42L456 47L475 54L491 61L506 70L519 79L531 90L540 103L548 116L554 132L559 149L561 170Z"};
  var COL = {"Blau":"#2f6db5","Braun":"#6b4a35","Grau":"#5a6068","Grün":"#2e7d4f","Graugrün":"#55756a","Cognac":"#c8743a","Amethyst":"#7a5a96","Cassis":"#a24a72","Coffee":"#7a4a22","Giallo":"#e0b800","Lido":"#2f5f95","Malve":"#8a3a55","Marrone":"#5e3a22","Nilgrün":"#3d9a9a","Rosso":"#c4262a","Rubino":"#9a2540","Seegras":"#7a8a5a","Tubal":"#b48a6a","Viola":"#5a3f96","Pastell Amethyst":"#a58ac0","Pastell Lagune":"#7fb0cc","Pastell Rauch":"#9aabab"};
  var DUO = {"Pfefferminz / Blau":["#7fc8b8","#5a9fd4"],"Nilgrün / Pink":["#5fb0b0","#e88fb4"],"Nougat / Lachs":["#c9a77c","#f0a58f"],"Grau / Rosé":["#8a929a","#e8a0a8"],"Braun / Rosé":["#8a6a52","#e8a0a8"],"Blau / Rosé":["#6f9fd0","#e8a0a8"],"Azurblau / Mandarin":["#4aa3df","#f2994a"],"Apfelcidre":["#a9ad6b","#d3a96a"]};
  /* Gravur-Position je Glasform (nach Vorlage der Glaszeichnungen), Koordinaten wie SHAPE_D (linkes Glas, von vorn gesehen) */
  var ENG = {"660":"M136.3 61.8L135.5 62.6L135.5 64.2L136.3 65.0L137.9 65.0L138.7 62.6L137.9 61.8ZM164.1 59.8L160.9 59.4L156.5 60.6L152.2 67.0L150.6 68.2L149.8 67.8L149.8 63.0L148.2 62.2L145.4 63.0L143.0 65.0L139.9 71.3L137.1 74.9L136.3 74.5L136.3 72.1L137.9 68.9L137.9 67.0L135.5 66.6L133.5 68.9L133.1 71.7L129.6 78.9L128.4 78.5L128.4 76.1L130.0 71.7L132.0 70.1L132.0 68.2L131.2 67.4L131.6 64.2L130.8 63.4L129.2 63.4L125.6 71.3L124.4 72.5L121.6 72.5L118.1 74.9L116.5 78.1L116.1 82.5L114.9 84.1L114.1 87.7L113.3 88.5L112.5 88.1L112.5 78.5L106.2 80.9L102.6 85.7L99.8 96.5L98.3 99.3L95.5 102.5L92.7 102.9L89.9 98.5L89.5 92.1L91.1 84.9L93.5 80.1L96.3 77.3L98.7 76.5L100.6 78.1L102.2 77.7L103.0 71.7L102.2 71.3L99.1 73.7L95.5 74.9L90.3 80.5L87.2 87.7L86.4 98.5L87.6 103.7L89.1 105.7L91.5 106.9L94.3 106.5L98.3 103.7L102.6 97.7L103.8 98.5L105.8 98.1L109.0 94.5L110.5 93.7L111.7 94.1L114.9 90.9L117.7 90.5L118.9 88.1L120.1 78.5L121.2 76.9L124.8 78.1L124.8 82.9L126.0 84.5L127.6 84.5L132.3 80.1L133.5 80.9L136.3 80.5L139.5 76.9L143.4 78.1L146.6 76.5L150.2 73.3L152.6 75.3L154.1 74.9L155.3 73.3L157.7 65.8L160.9 63.0L163.7 63.4L164.5 62.6ZM108.6 83.3L109.8 84.5L109.4 87.7L107.4 92.9L105.0 94.5L104.2 92.9L104.6 89.3L106.6 84.5ZM145.8 72.1L146.2 72.9L144.2 74.1L143.8 73.3ZM145.8 71.7L146.6 71.3L147.0 72.1L146.2 72.5Z","439":"M193.4 63.7L192.5 62.8L188.3 63.4L183.9 67.5L183.0 66.9L183.0 65.6L182.0 64.7L180.1 64.7L176.6 67.5L176.0 69.1L174.1 71.0L173.5 70.7L174.1 64.7L173.5 64.4L172.5 65.0L172.5 66.9L170.6 68.8L169.7 68.2L169.1 66.0L167.5 65.6L164.9 70.1L161.8 71.0L158.9 72.9L157.7 77.0L156.4 78.6L155.5 78.6L155.8 75.4L155.1 74.8L150.1 76.4L147.5 79.5L145.6 85.9L142.5 89.0L140.9 89.3L139.3 88.4L138.4 85.6L138.4 82.7L140.0 77.3L142.8 74.2L144.1 73.5L147.2 74.2L148.2 72.9L148.2 71.0L146.6 70.7L141.2 73.2L137.1 78.3L136.2 81.4L136.5 88.7L137.1 90.0L139.3 91.6L142.5 91.6L144.7 90.0L146.9 87.1L148.2 86.5L150.4 86.5L152.6 84.6L158.9 81.8L160.2 79.5L160.5 75.1L161.8 73.9L163.4 73.9L164.3 74.8L164.6 77.6L166.2 78.3L170.0 75.8L172.8 75.8L175.1 73.9L178.9 74.2L182.7 71.6L185.2 72.6L186.4 72.0L188.3 67.2L190.9 65.3L192.8 65.3ZM152.3 78.0L152.9 78.6L152.6 81.1L150.1 83.7L149.4 83.0L149.8 80.5L150.4 79.2ZM169.7 70.1L170.3 70.7L168.7 73.2L167.8 73.5L167.8 71.3Z","171":"M155.8 51.6L154.7 52.7L155.1 54.6L157.3 54.6L157.6 52.4ZM181.3 50.5L180.2 49.8L177.6 49.8L173.3 51.3L170.7 55.7L163.4 63.3L162.0 62.6L166.4 58.9L167.8 56.8L168.2 53.8L167.5 52.7L165.3 52.4L162.4 54.2L159.4 58.6L157.6 63.0L155.4 64.8L155.1 63.7L155.8 63.0L156.9 57.1L156.2 56.0L155.1 56.0L154.0 57.1L151.8 63.3L149.2 67.3L148.5 67.0L148.9 62.2L151.8 58.9L151.8 57.8L150.3 56.4L151.1 54.9L150.7 53.5L148.9 53.5L147.4 55.7L146.0 60.8L144.9 61.5L142.7 61.5L138.3 64.4L137.6 65.5L136.9 70.6L135.4 74.3L134.3 75.4L133.6 75.0L134.3 68.8L133.6 67.3L128.9 68.8L126.7 70.3L124.5 73.2L122.7 81.2L120.8 85.2L117.9 88.9L116.1 89.6L113.6 87.4L112.5 83.8L112.5 79.8L113.9 72.8L115.7 69.2L119.0 65.9L120.8 65.2L122.7 66.6L124.1 66.2L124.8 61.1L123.4 61.1L121.6 62.6L117.6 64.1L115.0 66.2L112.5 69.9L109.6 78.3L109.6 86.7L110.6 90.3L113.6 92.9L117.6 92.5L121.2 89.2L123.8 85.2L127.0 85.2L131.0 81.2L133.2 81.2L135.8 78.7L138.0 78.3L139.0 77.2L139.8 74.6L140.1 68.8L142.0 65.9L143.1 65.9L145.2 67.3L144.9 71.4L146.0 72.5L147.8 72.5L151.4 68.8L153.6 69.5L155.1 69.2L158.7 65.2L160.9 66.6L162.7 66.6L168.5 61.9L169.3 62.2L169.6 64.1L171.5 64.1L172.5 63.0L175.5 54.9L177.3 53.1L180.6 53.1L181.3 52.4ZM129.9 71.7L130.7 72.5L130.3 76.8L128.5 80.5L127.0 81.2L125.9 79.8L126.3 77.2L128.1 72.8ZM164.5 55.3L164.9 57.1L163.1 58.9L162.4 57.8Z","622":"M158.8 59.0L158.4 61.0L159.2 61.8L160.8 61.8L161.6 61.0L161.6 59.4L160.8 58.6ZM187.3 57.0L186.5 56.2L184.0 56.2L182.0 57.4L179.2 57.8L174.4 65.1L169.2 70.7L167.2 71.9L166.4 70.3L172.8 64.3L173.2 60.6L172.0 59.4L169.2 59.4L165.2 63.1L160.8 71.5L159.6 71.1L159.6 67.1L161.2 65.1L160.0 63.9L158.4 63.9L156.0 66.7L153.5 63.9L154.4 62.7L154.0 60.6L151.1 61.0L148.7 67.9L146.7 69.5L144.7 69.5L141.1 71.5L139.5 73.5L138.7 79.2L135.5 84.8L134.7 84.4L135.5 78.4L135.1 75.9L133.1 75.9L131.9 77.2L129.1 77.6L125.9 80.8L123.5 86.4L121.9 94.1L117.4 99.7L115.0 100.1L113.0 97.7L111.8 94.5L111.8 88.0L113.8 80.0L118.2 74.3L121.0 73.5L123.1 75.1L124.3 74.7L125.5 69.5L123.9 68.7L121.9 70.7L119.0 71.1L113.4 75.9L110.2 81.6L108.6 88.0L108.6 97.3L109.4 100.5L112.6 103.7L116.6 103.7L120.6 100.5L124.3 95.3L127.9 95.3L132.3 90.8L134.7 90.8L137.9 88.0L140.3 87.2L141.5 85.2L141.5 80.4L142.7 75.1L144.3 73.9L147.5 75.1L147.1 79.6L149.5 81.6L151.5 80.8L154.4 77.6L158.8 77.6L162.8 73.5L164.8 74.7L168.4 74.3L174.0 69.1L174.8 69.9L174.8 72.3L177.2 71.9L180.8 62.7L183.6 59.4L185.6 60.6L186.9 60.2L187.7 59.0ZM130.7 80.4L131.9 81.6L131.5 85.6L129.5 90.0L127.1 91.2L126.3 90.4L126.7 87.2L128.7 82.0ZM155.6 67.5L156.0 69.5L153.1 74.7L151.9 75.1L151.9 69.9L153.5 67.9ZM169.6 63.1L169.6 64.7L167.6 65.9L168.0 63.9Z","474":"M172.1 74.5L171.0 73.1L165.1 74.2L159.9 79.7L159.3 79.4L159.3 75.9L157.9 75.2L155.8 75.5L152.3 78.7L148.5 84.9L147.8 84.6L147.8 81.8L148.9 80.7L148.5 78.0L149.5 75.9L148.9 74.9L147.8 74.9L146.8 76.2L147.5 77.6L145.7 79.7L141.6 87.7L140.9 87.3L140.9 84.6L141.9 82.5L143.7 81.1L143.0 76.6L141.2 76.2L137.8 82.5L134.6 82.8L131.2 84.9L130.1 87.0L129.8 90.1L127.4 93.9L126.7 92.9L126.7 90.1L127.4 89.1L127.0 87.3L122.2 88.4L120.4 89.4L117.3 93.6L116.6 97.4L115.2 100.5L111.8 104.3L109.3 104.7L107.6 102.9L106.6 100.2L106.6 96.7L107.9 91.8L109.3 89.1L113.1 85.9L114.2 85.6L117.3 86.6L118.0 85.9L118.3 82.5L116.6 82.5L114.9 83.9L113.1 83.9L110.0 85.6L107.6 88.0L104.8 92.5L103.8 96.0L104.1 104.0L104.8 105.4L107.6 107.4L110.4 107.4L113.1 106.1L117.7 101.2L121.5 100.9L123.9 98.4L126.7 98.1L129.1 96.0L131.2 95.7L132.2 94.3L133.3 87.7L134.6 85.9L137.8 87.3L137.4 90.5L138.5 91.5L139.8 91.5L143.7 88.4L145.4 89.1L147.8 88.4L149.9 85.9L155.1 86.6L159.9 82.8L161.3 84.9L162.4 84.9L164.1 83.2L166.2 78.0L167.9 76.2L171.4 76.2ZM123.2 90.8L124.2 91.5L123.2 95.7L121.5 98.1L120.1 98.4L119.4 97.7L119.7 95.0L121.5 91.5ZM154.4 83.9L154.7 82.8L156.5 82.8L155.8 83.9ZM157.5 81.4L157.9 81.8L156.5 82.8L156.1 82.1ZM155.8 78.3L156.1 79.4L155.4 80.1L155.1 79.0Z","550":"M155.8 70.0L154.7 71.1L155.1 73.0L157.3 73.0L157.6 70.8ZM181.3 68.9L180.2 68.2L177.6 68.2L173.3 69.7L170.7 74.1L163.4 81.7L162.0 81.0L166.4 77.3L167.8 75.2L168.2 72.2L167.5 71.1L165.3 70.8L162.4 72.6L159.4 77.0L157.6 81.4L155.4 83.2L155.1 82.1L155.8 81.4L156.9 75.5L156.2 74.4L155.1 74.4L154.0 75.5L151.8 81.7L149.2 85.7L148.5 85.4L148.9 80.6L151.8 77.3L151.8 76.2L150.3 74.8L151.1 73.3L150.7 71.9L148.9 71.9L147.4 74.1L146.0 79.2L144.9 79.9L142.7 79.9L138.3 82.8L137.6 83.9L136.9 89.0L135.4 92.7L134.3 93.8L133.6 93.4L134.3 87.2L133.6 85.7L128.9 87.2L126.7 88.7L124.5 91.6L122.7 99.6L120.8 103.6L117.9 107.3L116.1 108.0L113.6 105.8L112.5 102.2L112.5 98.2L113.9 91.2L115.7 87.6L119.0 84.3L120.8 83.6L122.7 85.0L124.1 84.6L124.8 79.5L123.4 79.5L121.6 81.0L117.6 82.5L115.0 84.6L112.5 88.3L109.6 96.7L109.6 105.1L110.6 108.7L113.6 111.3L117.6 110.9L121.2 107.6L123.8 103.6L127.0 103.6L131.0 99.6L133.2 99.6L135.8 97.1L138.0 96.7L139.0 95.6L139.8 93.0L140.1 87.2L142.0 84.3L143.1 84.3L145.2 85.7L144.9 89.8L146.0 90.9L147.8 90.9L151.4 87.2L153.6 87.9L155.1 87.6L158.7 83.6L160.9 85.0L162.7 85.0L168.5 80.3L169.3 80.6L169.6 82.5L171.5 82.5L172.5 81.4L175.5 73.3L177.3 71.5L180.6 71.5L181.3 70.8ZM129.9 90.1L130.7 90.9L130.3 95.2L128.5 98.9L127.0 99.6L125.9 98.2L126.3 95.6L128.1 91.2ZM164.5 73.7L164.9 75.5L163.1 77.3L162.4 76.2Z","362":"M164.3 69.7L163.0 68.7L157.9 69.3L151.5 75.7L150.8 75.1L152.8 72.2L151.5 70.6L149.2 70.6L145.7 73.5L142.5 78.3L141.6 77.9L141.6 76.4L142.5 75.1L142.2 72.5L143.2 71.6L143.2 70.6L141.3 70.3L140.6 70.9L141.3 72.5L139.7 74.1L138.1 77.9L136.1 80.5L135.2 80.2L135.2 77.9L137.1 75.7L138.1 75.4L138.1 74.8L137.1 73.8L137.1 71.9L136.5 71.3L135.2 71.6L134.2 72.5L132.6 76.4L129.1 77.0L125.9 78.9L125.0 82.4L122.4 86.2L121.8 85.9L122.4 81.8L121.8 80.8L117.6 81.8L115.4 83.0L113.5 85.3L111.9 90.7L110.3 93.2L108.4 95.2L105.5 95.8L104.2 94.8L102.9 91.3L104.2 85.0L105.2 83.0L108.7 79.9L110.9 79.5L112.2 80.5L113.1 80.2L114.1 77.0L112.5 76.7L110.6 77.9L108.0 78.3L103.2 82.4L101.3 85.6L100.4 89.1L100.7 95.2L102.3 97.4L104.5 98.3L107.1 98.3L109.0 97.4L112.8 93.2L116.3 92.9L119.5 90.4L122.1 90.1L124.0 88.5L125.9 88.1L127.2 86.2L127.5 82.1L129.1 79.9L131.0 80.2L132.0 81.5L132.0 83.7L133.9 84.6L138.1 81.8L140.0 82.4L141.3 82.1L143.8 79.5L146.0 80.5L147.6 80.5L150.2 79.2L152.8 77.0L154.0 78.6L155.6 78.6L158.5 73.2L160.7 70.9L162.7 71.6L163.6 71.3ZM118.6 84.0L119.2 84.6L118.9 87.2L116.0 90.4L115.1 89.4L115.4 87.5L117.0 84.6ZM150.8 75.7L150.8 76.4L148.0 78.3L147.3 77.6L149.9 75.7ZM149.2 72.8L149.6 73.8L148.6 74.4L148.3 73.5Z"};
  function shapeKey(s) {
    if (!s.shape) return 'Original';
    if (/^Originalform/.test(s.shape)) return 'Original';
    var k = s.shape.split(' · ')[0];
    return SHAPE_D[k] ? k : 'Original';
  }
  function previewSvg(s) {
    var d = SHAPE_D[shapeKey(s)];
    var tintOn = s.extra === 'tint' || s.extra === 'trans';
    var fills = '', defs = '', mode = 'clear';
    var o = 0.5, c1 = null, c2 = null, kind = 'voll';
    if (s.extra === 'tint' && s.color) {
      if (s.colorGroup === 'duo') {
        var dd = DUO[s.color] || ['#888888', '#cccccc'];
        c1 = dd[0]; c2 = dd[1]; kind = 'duo';
        o = s.dpct ? Number(s.dpct) / 100 : 0.5;
      } else {
        c1 = COL[s.color] || '#666666';
        if (s.colorGroup === 'std') {
          if (s.tint === 'v30' || s.tint === 'v65') { kind = 'verlauf'; o = Number(s.tint.slice(1)) / 100; }
          else if (s.tint) { kind = 'voll'; o = Number(s.tint.slice(1)) / 100; }
        } else if (s.colorGroup === 'sonder') {
          kind = s.ttype === 'verlauf' ? 'verlauf' : 'voll';
          if (s.tpct) o = Number(s.tpct) / 100;
        }
      }
      mode = 'tint';
    } else if (s.extra === 'trans') {
      mode = 'trans'; c1 = s.trans === 'Braun' ? '#6b4a35' : '#4a4f55'; o = 0.78;
    }
    var f = function (x) { return Math.max(0, Math.min(1, x)).toFixed(2); };
    defs += '<linearGradient id="gcpv" x1="0" y1="0" x2="0" y2="1">';
    if (mode === 'tint' && kind === 'verlauf') {
      defs += '<stop offset="0" stop-color="' + c1 + '" stop-opacity="' + f(o) + '"/><stop offset="1" stop-color="' + c1 + '" stop-opacity="0"/>';
    } else if (mode === 'tint' && kind === 'duo') {
      defs += '<stop offset="0" stop-color="' + c1 + '" stop-opacity="' + f(o) + '"/><stop offset="1" stop-color="' + c2 + '" stop-opacity="' + f(o - 0.15) + '"/>';
    } else {
      var cc = c1 || '#ffffff', oo = mode === 'tint' || mode === 'trans' ? o : 0;
      defs += '<stop offset="0" stop-color="' + cc + '" stop-opacity="' + f(oo) + '"/><stop offset="1" stop-color="' + cc + '" stop-opacity="' + f(oo) + '"/>';
    }
    defs += '</linearGradient>';
    defs += '<clipPath id="gcpA"><path d="' + d + '"/></clipPath>';
    defs += '<clipPath id="gcpB"><path d="' + d + '" transform="translate(1260 0) scale(-1 1)"/></clipPath>';
    defs += '<linearGradient id="gcpg" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#fff" stop-opacity=".5"/><stop offset=".45" stop-color="#fff" stop-opacity=".08"/><stop offset="1" stop-color="#fff" stop-opacity="0"/></linearGradient>';
    var lensA = '<g clip-path="url(#gcpA)"><rect x="0" y="0" width="620" height="400" fill="#fff" fill-opacity=".5"/>';
    var lensB = '<g clip-path="url(#gcpB)"><rect x="640" y="0" width="620" height="400" fill="#fff" fill-opacity=".5"/>';
    if (mode === 'trans') {
      /* links getönt (Sonnenlicht), rechts klar (drinnen) */
      lensA += '<rect x="0" y="0" width="620" height="400" fill="url(#gcpv)"/>';
    } else if (mode === 'tint') {
      lensA += '<rect x="0" y="0" width="620" height="400" fill="url(#gcpv)"/>';
      lensB += '<rect x="640" y="0" width="620" height="400" fill="url(#gcpv)"/>';
    }
    if (s.add.indexOf('blue') > -1) {
      lensA += '<rect x="0" y="0" width="620" height="400" fill="#6f9bff" fill-opacity=".16"/>';
      lensB += '<rect x="640" y="0" width="620" height="400" fill="#6f9bff" fill-opacity=".16"/>';
    }
    lensA += '<rect x="0" y="0" width="620" height="400" fill="url(#gcpg)"/></g>';
    lensB += '<rect x="640" y="0" width="1240" height="400" fill="url(#gcpg)"/></g>';
    var edge = '#8a8174';
    var dash = shapeKey(s) === 'Original' ? ' stroke-dasharray="10 8"' : '';
    var svg = '<svg viewBox="0 0 1260 410" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Schematische Vorschau Ihrer Gläser"><defs>' + defs + '</defs>' +
      '<rect x="0" y="0" width="1260" height="410" rx="14" fill="#ece8e1"/>' +
      '<g transform="translate(0 5)">' + lensA + lensB +
      '<path d="' + d + '" fill="none" stroke="' + edge + '" stroke-width="3" stroke-linejoin="round"' + dash + '/>' +
      '<path d="' + d + '" transform="translate(1260 0) scale(-1 1)" fill="none" stroke="' + edge + '" stroke-width="3" stroke-linejoin="round"' + dash + '/>' +
      '<path d="M569 112 Q630 70 691 112" fill="none" stroke="' + edge + '" stroke-width="5" stroke-linecap="round"/>';
    if (s.add.indexOf('grav') > -1) {
      var eg = ENG[shapeKey(s)] || ENG['550'];
      svg += '<g clip-path="url(#gcpA)"><path d="' + eg + '" transform="translate(.8 .8)" fill="#000" fill-opacity=".28" fill-rule="evenodd"/><path d="' + eg + '" fill="#fff" fill-opacity=".95" fill-rule="evenodd" stroke="#fff" stroke-opacity=".95" stroke-width=".9"/></g>';
    }
    svg += '</g></svg>';
    return svg;
  }
  function previewChips(s) {
    var c = [];
    if (s.shape) c.push('Glasform ' + s.shape);
    if (s.extra === 'trans') c.push('Selbsttönend' + (s.trans ? ' ' + s.trans : ''));
    else if (s.extra === 'tint') { var tl = tintLabel(s); c.push('Tönung' + (s.color ? ' ' + s.color : '') + (tl ? ', ' + tl : '')); }
    else c.push('Klare Gläser');
    s.add.forEach(function (k) { c.push(ADD_LABEL[k]); });
    c.push(s.rx === 'yes' ? 'mit Sehstärke' : 'Planglas');
    return c.map(function (t) { return '<span class="gc__chipx">' + esc(t) + '</span>'; }).join('');
  }
  function preview() {
    var box = document.getElementById('gc_prev_view');
    if (!box) return;
    var s = state();
    var wrap = document.getElementById('gc_prev');
    var orig = !!s.shape && /^Originalform/.test(s.shape);
    if (wrap) wrap.style.display = orig ? 'none' : '';
    if (s.mode !== 'glas' || orig) { box.innerHTML = ''; box.removeAttribute('data-key'); return; }
    var key = JSON.stringify([s.shape, s.extra, s.color, s.colorGroup, s.tint, s.ttype, s.tpct, s.dpct, s.trans, s.add, s.rx]);
    if (box.getAttribute('data-key') === key) return;
    box.setAttribute('data-key', key);
    box.innerHTML = previewSvg(s) + '<div class="gc__chips">' + previewChips(s) + '</div>' +
      (s.extra === 'trans' ? '<p class="gc__note">Links: im Sonnenlicht (getönt). Rechts: drinnen (klar).</p>' : '');
  }

  /* ---------- Prüfung ---------- */
  function validate() {
    var s = state();
    var e = [];
    if (s.mode !== 'glas') return e;
    if (D.shapes > 0 && !s.shape) e.push('Bitte wählen Sie die Glasform.');
    if (s.extra === 'trans' && !s.trans) e.push('Bitte wählen Sie die Farbe der selbsttönenden Gläser (Grau oder Braun).');
    if (s.extra === 'tint') {
      if (!s.color) e.push('Bitte wählen Sie eine Tönungsfarbe.');
      else if (s.colorGroup === 'std' && !s.tint) e.push('Bitte wählen Sie die Tönungsstufe.');
      else if (s.colorGroup === 'sonder' && (!s.ttype || !s.tpct)) e.push('Bitte wählen Sie Vollton oder Verlauf und die Intensität.');
      else if (s.colorGroup === 'duo' && !s.dpct) e.push('Bitte wählen Sie die Intensität der Duocolor-Tönung.');
    }
    if (s.rx === 'yes') {
      if (!g('gc_sphR') || !g('gc_sphL')) e.push('Bitte geben Sie die Sphäre für beide Augen an.');
      ['R', 'L'].forEach(function (x) {
        var c = g('gc_cyl' + x);
        if (c && c !== '0,00' && !g('gc_ax' + x)) e.push('Bitte geben Sie die Achse für das ' + (x === 'R' ? 'rechte' : 'linke') + ' Auge an.');
      });
      if (!chk('gc_pd_unknown') && (!g('gc_pdR') || !g('gc_pdL'))) e.push('Bitte geben Sie die Pupillendistanz an oder markieren Sie „PD unbekannt“.');
      if (!chk('gc_consent')) e.push('Bitte bestätigen Sie die Einwilligung zur Verarbeitung Ihrer Sehstärke-Angaben.');
    }
    if (!chk('gc_ack')) e.push('Bitte bestätigen Sie den Hinweis zum Ausschluss des Widerrufsrechts bei Gläsern nach Maß.');
    return e;
  }
  function markInvalid(e) {
    $$('.gc-invalid').forEach(function (x) { x.classList.remove('gc-invalid'); });
    var first = null;
    function mark(el) { if (!el) return; el.classList.add('gc-invalid'); if (!first) first = el; }
    function lab(id) { var el = document.getElementById(id); return el ? (el.closest('label') || el) : null; }
    e.forEach(function (m) {
      if (/Glasform/.test(m)) mark($('#gc_shapes'));
      else if (/Transitions|selbstt/i.test(m)) mark($('#gc_trans_panel'));
      else if (/Tönung|Vollton|Duocolor/.test(m)) mark($('#gc_tint_panel'));
      else if (/Sphäre/.test(m)) { ['R', 'L'].forEach(function (x) { if (!g('gc_sph' + x)) mark(document.getElementById('gc_sph' + x)); }); }
      else if (/Achse/.test(m)) { var x2 = /rechte/.test(m) ? 'R' : 'L'; mark(document.getElementById('gc_ax' + x2)); }
      else if (/Pupillendistanz/.test(m)) { ['R', 'L'].forEach(function (x) { if (!g('gc_pd' + x)) mark(document.getElementById('gc_pd' + x)); }); }
      else if (/Einwilligung/.test(m)) mark(lab('gc_consent'));
      else if (/Widerruf/.test(m)) mark(lab('gc_ack'));
    });
    return first;
  }
  function showErrors(e, noScroll) {
    var box = $('#gc_err');
    var first = markInvalid(e);
    if (!e.length) { box.hidden = true; box.innerHTML = ''; return; }
    box.innerHTML = '<ul>' + e.map(function (m) { return '<li>' + m + '</li>'; }).join('') + '</ul>';
    box.hidden = false;
    if (noScroll) return;
    /* Zum ersten fehlerhaften Feld springen, die Liste bleibt unter dem Button stehen */
    try { (first || box).scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (x) { }
  }

  /* ---------- Eigenschaften für den Warenkorb ---------- */
  function rxText(e) {
    var c = g('gc_cyl' + e);
    var t = 'SPH ' + g('gc_sph' + e);
    if (c && c !== '0,00') t += ' · CYL ' + c + ' · ACH ' + g('gc_ax' + e) + '°';
    return t;
  }
  function frameProps(base, s, group) {
    var p = {};
    Object.keys(base).forEach(function (k) { p[k] = base[k]; });
    p['Lieferzeit'] = etaText().replace('Lieferzeit ', '').replace(/\.$/, '');
    p['Gläser'] = GLAS;
    if (s.shape) p['Glasform'] = s.shape;
    if (s.extra === 'trans') p['Veredelung'] = 'Selbsttönend (Transitions), ' + s.trans + ' (inklusive)';
    if (s.extra === 'tint') p['Veredelung'] = 'Tönung ' + tintLabel(s) + ', ' + s.color + ' (inklusive)';
    if (s.add.length) p['Zusatzoptionen'] = s.add.map(function (k) { return ADD_LABEL[k]; }).join(', ');
    if (s.rx === 'yes') {
      p['Sehstärke rechts'] = rxText('R');
      p['Sehstärke links'] = rxText('L');
      p['PD'] = chk('gc_pd_unknown') ? 'unbekannt, Messhilfe per E-Mail' : ('R ' + g('gc_pdR') + ' · L ' + g('gc_pdL'));
      p['_einwilligung_sehstaerke'] = 'ja';
    } else {
      p['Sehstärke'] = 'ohne (Planglas)';
    }
    p['_glas_typ'] = 'custom';
    p['_glas_gruppe'] = group;
    p['_glas_rolle'] = 'frame';
    return p;
  }
  function uid() { return 'g' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6); }

  window.GC_API = { state: state, lines: lines, validate: validate, showErrors: showErrors, frameProps: frameProps, isGlass: isGlass, uid: uid };

  /* ---------- Platzierung über dem Kaufbutton ---------- */
  function place() {
    var pf = document.querySelector('product-form');
    if (!pf || !pf.parentNode) return;
    if (root.nextElementSibling !== pf || root.parentNode !== pf.parentNode) pf.parentNode.insertBefore(root, pf);
    if (root.hidden) root.hidden = false;
  }
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; place(); });
  }).observe(document.body, { childList: true, subtree: true });
  place();

  function setAdd(k, on) {
    var el = root.querySelector('input[name="gc_add"][value="' + k + '"]');
    if (el) el.checked = on;
  }
  root.addEventListener('change', function (ev) {
    var t = ev.target;
    if (t && t.name === 'gc_add') {
      /* Schmuckfacette beinhaltet immer Sonderdicke, Cut-outs beinhalten Sonderdicke und Schmuckfacette */
      if (t.value === 'cut' && t.checked) { setAdd('facet', true); setAdd('dick', true); }
      if (t.value === 'facet') { if (t.checked) setAdd('dick', true); else setAdd('cut', false); }
      if (t.value === 'dick' && !t.checked) { setAdd('facet', false); setAdd('cut', false); }
    }
    apply();
    var e = $('#gc_err');
    if (e && !e.hidden) showErrors(validate(), true);
  });

  var lastId = frameId();
  setInterval(function () {
    var cur = frameId();
    if (cur !== lastId) { lastId = cur; render(); }
  }, 500);

  apply();
  wrapStatic();
})();
